import React, { useState, useEffect } from "react";
import "./CraftCounter.css";
import { useNavigate } from "react-router-dom";
import Vendors from "./Vendors";
import Inventory from "./Inventory";
import Inwards from "./Inwards";
import Outwards from "./Outwards";
import Reportscraft from "./Reportscraft";

/* =========================
   ICONS
========================= */

const MenuIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);


const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <line x1="6" y1="6" x2="18" y2="18" />
    <line x1="18" y1="6" x2="6" y2="18" />
  </svg>
);


const SearchIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <circle cx="11" cy="11" r="7" />
    <line x1="16.5" y1="16.5" x2="21" y2="21" />
  </svg>
);


const BellIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
    <path d="M10 21h4" />
  </svg>
);


const UserIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 3.5-7 8-7s8 3 8 7" />
  </svg>
);


const ChevronDownIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);


/* =========================
   CRAFTY COUNTER
========================= */

const CraftCounter = () => {

  const navigate = useNavigate();

  // Get logged-in user's email
  const userEmail = sessionStorage.getItem("userEmail");


  const [activePage, setActivePage] = useState(null);

  const [menuOpen, setMenuOpen] = useState(false);

  const [userMenuOpen, setUserMenuOpen] = useState(false);


  /* =========================
     CHECK LOGIN
  ========================== */

  useEffect(() => {

    if (!userEmail) {
      navigate("/signin");
    }

  }, [userEmail, navigate]);


  const menuItems = [
    "Dashboard",
    "Products",
    "Vendors",
    "Inventory",
    "Inwards",
    
    "Procurement",
    "Invoices",
    "Payments",
    "Reports",
    "Settings",
  ];


  const handleMenuClick = (page) => {

    setActivePage(page);

    // Close side menu
    setMenuOpen(false);

  };


  /* =========================
     LOGOUT
  ========================== */

  const handleLogout = () => {

    sessionStorage.removeItem("userEmail");

    setUserMenuOpen(false);

    navigate("/");

  };


  return (

    <div className="crafty-counter">


      {/* =========================
          TOP HEADER
      ========================== */}

      <header className="crafty-header">


        {/* LEFT SIDE */}

        <div className="header-left">


          {/* Hamburger */}

          <button
            className="menu-button"
            onClick={() => setMenuOpen(true)}
            title="Menu"
          >
            <MenuIcon />
          </button>


          {/* Application Name */}

          <div className="crafty-title">
            Craft Counter
          </div>

        </div>


        {/* RIGHT SIDE */}

        <div className="header-right">


          {/* =========================
              SEARCH
          ========================== */}

          <div className="search-container">

            <SearchIcon />

            <input
              type="text"
              placeholder="Search..."
              className="search-input"
            />

          </div>


          {/* =========================
              NOTIFICATIONS
          ========================== */}

          <button
            className="notification-button"
            title="Notifications"
          >
            <BellIcon />
          </button>


          {/* =========================
              USER
          ========================== */}

          <div className="user-container">

            <button
              className="user-button"
              onClick={() =>
                setUserMenuOpen(!userMenuOpen)
              }
            >

              <UserIcon />

              <span>User</span>

              <ChevronDownIcon />

            </button>


            {/* User Dropdown */}

            {userMenuOpen && (

              <div className="user-dropdown">


                {/* Profile */}

                <div className="profile-section">

                  <div className="profile-icon">
                    <UserIcon />
                  </div>

                  <div className="profile-details">

                    <div className="profile-name">
                      Profile
                    </div>

                    <div className="profile-email">
                      {userEmail}
                    </div>

                  </div>

                </div>


                <div className="dropdown-divider"></div>


                {/* Logout */}

                <button
                  onClick={handleLogout}
                >
                  Logout
                </button>


              </div>

            )}

          </div>

        </div>

      </header>



      {/* =========================
          SIDE MENU OVERLAY
      ========================== */}

      {menuOpen && (

        <div
          className="menu-overlay"
          onClick={() => setMenuOpen(false)}
        ></div>

      )}



      {/* =========================
          SIDE MENU
      ========================== */}

      <aside
        className={`side-menu ${
          menuOpen ? "side-menu-open" : ""
        }`}
      >


        {/* Side Menu Header */}

        <div className="side-menu-header">

          <div className="side-menu-title">
            Craft Counter
          </div>


          <button
            className="close-menu-button"
            onClick={() => setMenuOpen(false)}
            title="Close Menu"
          >
            <CloseIcon />
          </button>

        </div>


        {/* Menu Items */}

        <nav className="side-menu-navigation">

          {menuItems.map((item) => (

            <button
              key={item}
              className={`side-menu-item ${
                activePage === item
                  ? "side-menu-item-active"
                  : ""
              }`}
              onClick={() => handleMenuClick(item)}
            >

              {item}

            </button>

          ))}

        </nav>

      </aside>


{/* =========================
    PAGE CONTENT
========================== */}

<main className="crafty-content">

  {/* =========================
      INITIAL WELCOME SCREEN
  ========================== */}

{/* =========================
    INITIAL WELCOME SCREEN
========================== */}

{activePage === null && (
  <div className="craft-welcome">

    {/* Decorative floating elements */}
    <div className="craft-floating craft-floating-1"></div>
<div className="craft-floating craft-floating-2"></div>
<div className="craft-floating craft-floating-3"></div>
<div className="craft-floating craft-floating-4"></div>

    {/* Main Illustration */}
    <div className="craft-illustration">

      <svg
        viewBox="0 0 420 330"
        xmlns="http://www.w3.org/2000/svg"
        className="craft-svg"
      >

        {/* Soft decorative background */}
        <circle
          cx="210"
          cy="160"
          r="135"
          fill="#fff7ed"
        />

        <circle
          cx="210"
          cy="160"
          r="105"
          fill="#fef3c7"
          opacity="0.45"
        />


        {/* Leaves behind basket */}
        <path
          d="M92 115 C55 82 45 47 72 35 C105 52 111 83 92 115Z"
          fill="#86a889"
        />

        <path
          d="M328 115 C365 82 375 47 348 35 C315 52 309 83 328 115Z"
          fill="#9bb58e"
        />

        <path
          d="M72 43 C82 68 88 88 92 112"
          stroke="#5f7d63"
          strokeWidth="3"
          fill="none"
        />

        <path
          d="M348 43 C338 68 332 88 328 112"
          stroke="#6f8d71"
          strokeWidth="3"
          fill="none"
        />


        {/* Basket handle */}
        <path
          d="M118 145 C118 65 302 65 302 145"
          stroke="#9a633d"
          strokeWidth="13"
          fill="none"
          strokeLinecap="round"
        />

        <path
          d="M128 143 C128 78 292 78 292 143"
          stroke="#d4a373"
          strokeWidth="5"
          fill="none"
          strokeLinecap="round"
        />


        {/* Basket body */}
        <path
          d="M92 137
             C95 128 103 123 114 123
             H306
             C317 123 325 128 328 137
             L307 247
             C305 257 297 263 287 263
             H133
             C123 263 115 257 113 247
             Z"
          fill="#c58b5a"
        />


        {/* Basket upper rim */}
        <path
          d="M91 137
             C91 126 100 118 112 118
             H308
             C320 118 329 126 329 137
             C329 147 320 153 308 153
             H112
             C100 153 91 147 91 137Z"
          fill="#a9683e"
        />


        {/* Basket woven lines */}
        <path
          d="M119 153 L129 253"
          stroke="#9a6039"
          strokeWidth="6"
          opacity="0.8"
        />

        <path
          d="M153 153 L159 258"
          stroke="#9a6039"
          strokeWidth="6"
          opacity="0.8"
        />

        <path
          d="M188 153 L190 261"
          stroke="#9a6039"
          strokeWidth="6"
          opacity="0.8"
        />

        <path
          d="M223 153 L223 261"
          stroke="#9a6039"
          strokeWidth="6"
          opacity="0.8"
        />

        <path
          d="M258 153 L252 258"
          stroke="#9a6039"
          strokeWidth="6"
          opacity="0.8"
        />

        <path
          d="M292 153 L281 253"
          stroke="#9a6039"
          strokeWidth="6"
          opacity="0.8"
        />


        {/* Horizontal weaving */}
        <path
          d="M105 177 H314"
          stroke="#dda879"
          strokeWidth="5"
          opacity="0.8"
        />

        <path
          d="M108 205 H309"
          stroke="#dda879"
          strokeWidth="5"
          opacity="0.8"
        />

        <path
          d="M113 232 H304"
          stroke="#dda879"
          strokeWidth="5"
          opacity="0.8"
        />


        {/* Yarn ball */}
        <circle
          cx="150"
          cy="102"
          r="39"
          fill="#8b5cf6"
        />

        <path
          d="M121 105
             C133 82 158 77 180 98"
          stroke="#ede9fe"
          strokeWidth="5"
          fill="none"
          strokeLinecap="round"
        />

        <path
          d="M119 117
             C137 98 164 99 181 116"
          stroke="#ede9fe"
          strokeWidth="5"
          fill="none"
          strokeLinecap="round"
        />

        <path
          d="M127 130
             C145 116 166 117 177 130"
          stroke="#ede9fe"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
        />


        {/* Needle / knitting sticks */}
        <line
          x1="177"
          y1="73"
          x2="222"
          y2="108"
          stroke="#7c5c42"
          strokeWidth="4"
          strokeLinecap="round"
        />

        <circle
          cx="224"
          cy="109"
          r="4"
          fill="#7c5c42"
        />


        {/* Small handmade flower */}
        <circle
          cx="270"
          cy="88"
          r="10"
          fill="#f59e0b"
        />

        <circle
          cx="257"
          cy="82"
          r="10"
          fill="#fb7185"
        />

        <circle
          cx="282"
          cy="82"
          r="10"
          fill="#fb7185"
        />

        <circle
          cx="270"
          cy="72"
          r="10"
          fill="#f472b6"
        />

        <circle
          cx="270"
          cy="88"
          r="5"
          fill="#fbbf24"
        />


        {/* Scissors */}
        <circle
          cx="254"
          cy="184"
          r="11"
          stroke="#475569"
          strokeWidth="4"
          fill="#ffffff"
        />

        <circle
          cx="282"
          cy="184"
          r="11"
          stroke="#475569"
          strokeWidth="4"
          fill="#ffffff"
        />

        <path
          d="M262 178 L306 154"
          stroke="#475569"
          strokeWidth="4"
          strokeLinecap="round"
        />

        <path
          d="M274 178 L306 209"
          stroke="#475569"
          strokeWidth="4"
          strokeLinecap="round"
        />


        {/* Small craft tags */}
        <path
          d="M79 175 L102 175 L102 198 L79 198 Z"
          fill="#fef3c7"
          transform="rotate(-18 90 186)"
        />

        <circle
          cx="88"
          cy="182"
          r="3"
          fill="#a16207"
        />


        {/* Small sparkle */}
        <path
          d="M338 164 L342 176 L354 180 L342 184 L338 196 L334 184 L322 180 L334 176Z"
          fill="#f59e0b"
        />

      </svg>

    </div>


    {/* Welcome text */}
    <div className="craft-welcome-content">

    <div className="craft-small-label">
  <span className="label-decor"></span>
  <span>HANDMADE</span>
  <i></i>
  <span>CREATIVE</span>
  <i></i>
  <span>TIMELESS</span>
  <span className="label-decor"></span>
</div>

      <h1 className="craft-welcome-title">
        Welcome to
        <span> Craft Counter</span>
      </h1>

      <p className="craft-welcome-text">
        Bring every little detail of your craft together.
        
      </p>

      <div className="craft-welcome-line">
        <span></span>
       <div className="craft-welcome-words">
  <span>Craft</span>
  <i></i>
  <span>Curate</span>
  <i></i>
  <span>Create</span>
</div>        <span></span>
      </div>

      <p className="craft-welcome-hint">
        Bring your imagination to life
      </p>

    </div>

  </div>
)}

  {/* =========================
      DASHBOARD
  ========================== */}

  {activePage === "Dashboard" && (
    <div className="page-container">

      <div className="content-header">
        <h1>Dashboard</h1>
      </div>

      <div className="content-area">

        <div className="placeholder-page">

          <h2>Dashboard</h2>

          <p>
            Dashboard content will appear here.
          </p>

        </div>

      </div>

    </div>
  )}


  {/* =========================
      PRODUCTS
  ========================== */}

  {activePage === "Products" && (
    <div className="page-container">

      <div className="content-header">
        <h1>Products</h1>
      </div>

      <div className="content-area">

        <div className="placeholder-page">

          <h2>Products</h2>

          <p>
            Products content will appear here.
          </p>

        </div>

      </div>

    </div>
  )}


{/* =========================
    VENDORS
========================== */}

{activePage === "Vendors" && (
  <div className="page-container">

    <div className="content-header">
      <h1>Vendors</h1>
    </div>

    <div className="content-area">
      <Vendors />
    </div>

  </div>
)}

 {/* =========================
    INVENTORY
========================== */}

{activePage === "Inventory" && (
  <div className="page-container">

    <div className="content-header">
      <h1>Inventory</h1>
    </div>

    <div className="content-area">
      <Inventory />
    </div>

  </div>
)}



 {/* =========================
    Inwards
========================== */}

{activePage === "Inwards" && (
  <div className="page-container">

    <div className="content-header">
      <h1>Inwards</h1>
    </div>

    <div className="content-area">
      <Inwards />
    </div>

  </div>
)}



 {/* =========================
    Outwards
========================== */}

{activePage === "Outwards" && (
  <div className="page-container">

    <div className="content-header">
      <h1>Outwards</h1>
    </div>

    <div className="content-area">
      <Outwards />
    </div>

  </div>
)}


  {/* =========================
      PROCUREMENT
  ========================== */}

  {activePage === "Procurement" && (
    <div className="page-container">

      <div className="content-header">
        <h1>Procurement</h1>
      </div>

      <div className="content-area">

        <div className="placeholder-page">

          <h2>Procurement</h2>

          <p>
            Procurement content will appear here.
          </p>

        </div>

      </div>

    </div>
  )}


  {/* =========================
      INVOICES
  ========================== */}

  {activePage === "Invoices" && (
    <div className="page-container">

      <div className="content-header">
        <h1>Invoices</h1>
      </div>

      <div className="content-area">

        <div className="placeholder-page">

          <h2>Invoices</h2>

          <p>
            Vendor invoice content will appear here.
          </p>

        </div>

      </div>

    </div>
  )}


  {/* =========================
      PAYMENTS
  ========================== */}

  {activePage === "Payments" && (
    <div className="page-container">

      <div className="content-header">
        <h1>Payments</h1>
      </div>

      <div className="content-area">

        <div className="placeholder-page">

          <h2>Payments</h2>

          <p>
            Vendor payment content will appear here.
          </p>

        </div>

      </div>

    </div>
  )}


  {/* =========================
      REPORTS
  ========================== */}

{activePage === "Reports" && (
    <div className="page-container">

        <div className="content-area">
            <Reportscraft />
        </div>

    </div>
)}

  {/* =========================
      SETTINGS
  ========================== */}

  {activePage === "Settings" && (
    <div className="page-container">

      <div className="content-header">
        <h1>Settings</h1>
      </div>

      <div className="content-area">

        <div className="placeholder-page">

          <h2>Settings</h2>

          <p>
            Settings content will appear here.
          </p>

        </div>

      </div>

    </div>
  )}

</main>
    </div>

  );

};


export default CraftCounter;